import React, { HTMLAttributes } from 'react';

export interface ApparelLogoProps extends HTMLAttributes<SVGSVGElement> {
    color?: string;
    circleColor?: string;
    infinityColor1?: string;
    infinityColor2?: string;
    height?: number;
    hideLetters?: boolean;
    hideShadow?: boolean;
    alt?: string;
    variant?: 'default' | 'simple';
}

export function ApparelLogo({ ...props }) {
    const color = props.color || '#000';
    const hideLetters = typeof props.hideLetters !== 'undefined' ? props.hideLetters : false;

    let circleColor = props.circleColor || '#ef5350';
    let infinityColor1 = props.infinityColor1 || '#19b1f9';
    let infinityColor2 = props.infinityColor2 || '#fff';
    let hideShadow = typeof props.hideShadow !== 'undefined' ? props.hideShadow : false;

    const height = props.height || '50px';
    const alt = props.alt || 'Wooter Apparel';
    const variant = props.variant || 'default';
    const style = { ...props.style, height };

    if (variant === 'simple') {
        circleColor = 'transparent';
        hideShadow = true;
        infinityColor1 = color;
        infinityColor2 = color;
    }

    const svgHeight = '182.33';
    const svgWidth = hideLetters ? svgHeight : '792';

    return (
        <svg
            className={props.className || ''}
            id="logo"
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 ${svgWidth} ${svgHeight}`}
            style={style}
        >
            <title>{alt}</title>

            {!hideShadow ? (
                <g opacity="0.2">
                    <path
                        d="M180.83,327.92,140,287.12l-5.6,2.4-20-3.9-16.62,6-11.43-1.3s-17.4-4.16-18.7-4.16-19,2.86-19,2.86L39,305.11l4,31L108,401A91.26,91.26,0,0,0,180.83,327.92Z"
                        transform="translate(0 -220.21)"
                    />
                </g>
            ) : null}

            <path
                fill={color}
                d="M225.37,252.2l15,33.85,14.91-33.48H269l14.88,33.48,14.95-33.85h15l-22.45,50.58H277.61l-15.47-33.45-15.47,33.45H232.91L210.42,252.2Z"
                transform="translate(0 -220.21)"
            />
            <path
                fill={color}
                d="M395.58,252.2a16.47,16.47,0,0,1,11.52,4.32A13.48,13.48,0,0,1,411.83,267v21a13.47,13.47,0,0,1-4.72,10.45,16.46,16.46,0,0,1-11.52,4.32H356a16.54,16.54,0,0,1-11.51-4.32A13.64,13.64,0,0,1,339.8,288V267a13.65,13.65,0,0,1,4.72-10.45A16.54,16.54,0,0,1,356,252.2Zm-40.09,13a5.27,5.27,0,0,0-1.88,4.17v16.25a5.6,5.6,0,0,0,1.88,4.21,6.9,6.9,0,0,0,4.62,1.69h31.42a7.21,7.21,0,0,0,4.62-1.73,5.56,5.56,0,0,0,1.88-4.17V269.36a5.37,5.37,0,0,0-1.88-4.2,6,6,0,0,0-4.62-1.7H360.11A6.35,6.35,0,0,0,355.49,265.19Z"
                transform="translate(0 -220.21)"
            />
            <path
                fill={color}
                d="M495.46,252.2A16.46,16.46,0,0,1,507,256.52,13.49,13.49,0,0,1,511.71,267v21A13.48,13.48,0,0,1,507,298.46a16.45,16.45,0,0,1-11.52,4.32H455.92a16.54,16.54,0,0,1-11.52-4.32A13.64,13.64,0,0,1,439.68,288V267a13.65,13.65,0,0,1,4.72-10.45,16.55,16.55,0,0,1,11.52-4.32Zm-40.09,13a5.26,5.26,0,0,0-1.88,4.17v16.25a5.59,5.59,0,0,0,1.88,4.21,6.89,6.89,0,0,0,4.62,1.69H491.4a7.2,7.2,0,0,0,4.61-1.73,5.56,5.56,0,0,0,1.88-4.17V269.36a5.37,5.37,0,0,0-1.88-4.2,6,6,0,0,0-4.61-1.7H460A6.35,6.35,0,0,0,455.37,265.19Z"
                transform="translate(0 -220.21)"
            />
            <path
                fill={color}
                d="M605.75,252.2v11.26H579.54v39.31H565.73V263.46H539.56V252.2Z"
                transform="translate(0 -220.21)"
            />
            <path
                fill={color}
                d="M696,252.2v11.26H647.38v8.27h42.16V282.8H647.38v8.71H696v11.26H633.57V252.2Z"
                transform="translate(0 -220.21)"
            />
            <path
                fill={color}
                d="M773.5,252.2a18,18,0,0,1,12.55,4.73,14.87,14.87,0,0,1,5.21,11.41,14.7,14.7,0,0,1-4.5,10.71,18.54,18.54,0,0,1-11.23,5.21L792,302.78H775.94l-15.21-18.35H737.65v18.35H723.85V252.2Zm-35.85,21.08,34.52,0a5.31,5.31,0,0,0,3.88-1.41,4.53,4.53,0,0,0,1.51-3.54,4.33,4.33,0,0,0-1.51-3.54,4.84,4.84,0,0,0-3.88-1.36H737.65Z"
                transform="translate(0 -220.21)"
            />
            <path
                fill={color}
                d="M241.45,326.28l-.18-.28h-2.63l-.13.2-28.09,44.35h2.94l6.91-10.85h39.49l6.83,10.85h3Zm-19.9,31.39L240,328.55l18.4,29.11Z"
                transform="translate(0 -220.21)"
            />
            <path
                fill={color}
                d="M298.75,370.55V326h43.7a15.4,15.4,0,0,1,7.44,1.78,13.36,13.36,0,0,1,5.26,4.76,11.35,11.35,0,0,1,1.84,6.3c0,2.27-.61,5.91-1.86,7.86a13.17,13.17,0,0,1-5.21,4.73,15.65,15.65,0,0,1-7.46,1.76H301.81v17.37Zm3.07-19.4h39.51c3-.11,7.22-1.07,9.27-2.84l.11-.1c2.22-2,3.39-6.32,3.39-9.37a10.1,10.1,0,0,0-3.42-7.82c-2.06-1.91-6.34-2.91-9.4-2.91H301.81Z"
                transform="translate(0 -220.21)"
            />
            <path
                fill={color}
                d="M386.62,370.55V326h43.7a15.4,15.4,0,0,1,7.44,1.78,13.36,13.36,0,0,1,5.26,4.76,11.34,11.34,0,0,1,1.84,6.3c0,2.27-.61,5.91-1.86,7.86a13.17,13.17,0,0,1-5.21,4.73,15.65,15.65,0,0,1-7.46,1.76H389.68v17.37Zm3.07-19.4H429.2c3-.11,7.22-1.07,9.27-2.84l.11-.1c2.22-2,3.39-6.32,3.39-9.37a10.1,10.1,0,0,0-3.43-7.82c-2.06-1.91-6.34-2.91-9.4-2.91H389.68Z"
                transform="translate(0 -220.21)"
            />
            <path
                fill={color}
                d="M505.06,326.28l-.18-.28h-2.63l-.13.2L474,370.55H477l6.91-10.85h39.49l6.83,10.85h3Zm-19.9,31.39,18.45-29.11L522,357.66Z"
                transform="translate(0 -220.21)"
            />
            <path
                fill={color}
                d="M618.76,332.54a13.36,13.36,0,0,0-5.26-4.76,15.4,15.4,0,0,0-7.44-1.78h-43.7v44.55h3.07V353.18h33.08l14.09,17.37h3.07l-14.09-17.37h4.48a15.65,15.65,0,0,0,7.46-1.76,13.17,13.17,0,0,0,5.21-4.73c1.25-1.94,1.86-5.58,1.86-7.86A11.35,11.35,0,0,0,618.76,332.54Zm-4.43,15.66-.11.1c-2.05,1.77-6.23,2.73-9.27,2.84H565.43v-23h39.46c3.05,0,7.34,1,9.4,2.91a10.1,10.1,0,0,1,3.43,7.82C617.71,341.88,616.54,346.15,614.33,348.2Z"
                transform="translate(0 -220.21)"
            />

            <polygon
                fill={color}
                points="653.51 150.34 653.51 105.79 705.18 105.79 705.18 108.06 656.58 108.06 656.58 126.79 698.69 126.79 698.69 128.86 656.58 128.86 656.58 148.07 705.18 148.07 705.18 150.34 653.51 150.34"
            />
            <polygon
                fill={color}
                points="743.4 148.07 743.4 105.79 740.33 105.79 740.33 150.34 792 150.34 792 148.07 743.4 148.07"
            />

            <circle fill={circleColor} cx="91.17" cy="91.17" r="91.17" />

            <path
                fill={infinityColor1}
                d="M140.59,287.94c-7.68-8.26-19.77-11.64-30.73-9.4-7.31,1.33-13.67,5.65-18.94,10.74l0,0c-1.49,1.4-5.27,5-9.05,8.87-4.06,4.13-8.12,8.53-9.34,10.7-2.25,4.67,3.29,10.45,8,8.07,4.85-2.85,8.17-7.58,12.27-11.32,5.74-5.33,10.59-12.37,18.38-14.81,11.48-3.32,24.37,5.31,26.09,17,2.3,12.21-8.63,24.88-21.06,24.25-6.11,0-11.54-3.26-15.69-7.52-3.78,3.85-7.56,7.47-9.05,8.87,4.65,4.43,10,8.27,16.28,10.05,13,3.29,27.92-1.55,35.85-12.53C153,318.37,151.6,299.14,140.59,287.94Z"
                transform="translate(0 -220.21)"
            />
            <path
                fill={infinityColor2}
                d="M101.83,305.81c-4.85,2.85-8.17,7.58-12.27,11.32C83.82,322.46,79,329.5,71.18,331.94c-11.48,3.32-24.37-5.31-26.09-17-2.3-12.21,8.63-24.88,21.06-24.25,6.11,0,11.54,3.26,15.69,7.52,3.78-3.85,7.56-7.47,9.05-8.87-4.65-4.43-10-8.27-16.28-10.05-13-3.29-27.92,1.55-35.85,12.53-9.47,12.59-8,31.83,3,43,7.68,8.26,19.77,11.64,30.73,9.4,7.32-1.33,13.67-5.65,18.94-10.74l0,0c1.49-1.4,5.27-5,9.05-8.87,4.06-4.13,8.12-8.53,9.33-10.7C112.07,309.21,106.53,303.43,101.83,305.81Z"
                transform="translate(0 -220.21)"
            />
        </svg>
    );
}

export default ApparelLogo;
